import React, {useContext, useEffect, useState} from 'react'
import { useIntl } from 'react-intl'
import Checkbox from 'antd/es/checkbox'
import {ConnectorViewMappingContext} from './context/context'
import {useNavigate, useParams} from 'react-router-dom'
import {getRandomString} from '../../../utils/common'
import {AppstoreOutlined, CheckOutlined, MoreOutlined, PrinterOutlined, StopOutlined,} from '@ant-design/icons'
import {Button, Dropdown, Space, Tooltip} from 'antd'
import DuplicateReferences from './DuplicateReferences'

const SvgViewerToolbar = (props) => {
  const intl = useIntl();
  const {vehicle, connector_view} = useParams()
  const navigate = useNavigate()

  const [state, dispatch] = useContext(ConnectorViewMappingContext)
  const svgLoaded = state.svgLoaded

  const CHECKBOX_ITEMS = [
    {key: 'displayGroups', label: intl.formatMessage({id: 'connectorViews.mapping.svgGroups'})},
    {key: 'displayMappings', label: intl.formatMessage({id: 'connectorViews.mapping.mappings'})},
    {key: 'displayPng', label: intl.formatMessage({id: 'connectorViews.mapping.png'})},
    {key: 'displayConnector', label: intl.formatMessage({id: 'connectorViews.mapping.connectorLabel'})},
  ]

  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 1024 : false
  )

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1024px)')
    const handler = (e) => setIsMobile(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  const toggleCheckBox = (key) => {
    if (!svgLoaded) return
    dispatch({type: key, data: !state[`${key}`]})
  }

  const layersMenuItems = CHECKBOX_ITEMS.map(({key, label}) => ({
    key,
    label,
    icon: state[key] ? <CheckOutlined /> : null,
    onClick: () => toggleCheckBox(key),
  }))

  const actionsMenuItems = [
    {
      key: 'print',
      label: intl.formatMessage({id: 'connectorViews.mapping.print'}),
      icon: <PrinterOutlined />,
      disabled: !svgLoaded,
      onClick: () =>
        window.open(
          `/vehicles/${vehicle}/connector_views/${connector_view}/print?hide-nav=${getRandomString()}`,
          '_blank'
        ),
    },
    {
      key: 'cancel',
      label: intl.formatMessage({id: 'forms.cancel'}),
      icon: <StopOutlined />,
      danger: true,
      onClick: () => navigate(`/vehicles/${vehicle}/connector_views`),
    },
  ]

  const connectorTitle = (
    <Tooltip title={state.connector_view?.name}>
      <div className="connector-mapping-toolbar-title bolder">
        {state.connector_view?.name}
      </div>
    </Tooltip>
  )

  return (
    <div className={`connector-mapping-toolbar ${isMobile ? 'connector-mapping-toolbar--mobile' : ''}`}>
      <Space direction="horizontal" size="middle" className="connector-mapping-toolbar-left">
        {connectorTitle}

        {isMobile ? (
          <>
            <Dropdown
              menu={{items: layersMenuItems}}
              trigger={['click']}
              placement="bottomLeft"
            >
              <Button
                icon={<AppstoreOutlined />}
                disabled={!svgLoaded}
                className="connector-mapping-toolbar-menu-btn"
              >
                {intl.formatMessage({id: 'connectorViews.mapping.layers'})}
              </Button>
            </Dropdown>

            <DuplicateReferences disabled={!svgLoaded} />

            <Dropdown
              menu={{items: actionsMenuItems}}
              trigger={['click']}
              placement="bottomRight"
            >
              <Button
                icon={<MoreOutlined />}
                disabled={!svgLoaded}
                className="connector-mapping-toolbar-menu-btn"
              >
                {intl.formatMessage({id: 'connectorViews.mapping.actions'})}
              </Button>
            </Dropdown>
          </>
        ) : (
          <Space
            direction="horizontal"
            size="middle"
            className="ant-checkbox-group ant-form-item-inline connector-mapping-toolbar-checkboxes"
          >
            {CHECKBOX_ITEMS.map(({key, label}) => (
              <Checkbox
                key={key}
                data-testid="vv-layer-toggle"
                data-layer={key}
                checked={state[key]}
                disabled={!svgLoaded}
                onChange={() => toggleCheckBox(key)}
              >
                {label}
              </Checkbox>
            ))}
          </Space>
        )}
      </Space>

      {!isMobile && (
        <div className="connector-mapping-toolbar-actions">
          <DuplicateReferences disabled={!svgLoaded} />
          <Button
            icon={<PrinterOutlined />}
            href={`/vehicles/${vehicle}/connector_views/${connector_view}/print?hide-nav=${getRandomString()}`}
            target="_blank"
            disabled={!svgLoaded}
            data-testid="vv-print"
          >
            {intl.formatMessage({id: 'connectorViews.mapping.print'})}
          </Button>
          <Button
            danger
            onClick={() => navigate(`/vehicles/${vehicle}/connector_views`)}
            data-testid="vv-mapping-cancel"
          >
            {intl.formatMessage({id: 'forms.cancel'})}
          </Button>
        </div>
      )}
    </div>
  )
}

export default SvgViewerToolbar
